// utils/updateProductOrdersArray.js
import { doc, updateDoc, arrayUnion, arrayRemove, increment } from "firebase/firestore"
import { db } from "../firebase/config"

/**
 * Manages active orders array in product document
 * @param {string} action - "create" or "remove"
 * @param {object} order - The order object containing all necessary data
 * @returns {Promise<boolean>} - Success status
 */
export const updateProductOrdersArray = async (action, order) => {
  try {
    if (!order || !order.orderNumber || !order.selectedProduct?.id) {
      console.error("Missing required order data")
      return false
    }

    const orderNumber = order.orderNumber
    const productId = order.selectedProduct.id
    const collectionName =
      order.selectedProduct.machine === "Tape" ? "tapePrices" : "priceCalculation"

    const productRef = doc(db, collectionName, productId)

    if (action === "create") {
      await updateDoc(productRef, {
        currentlyInOrders: arrayUnion(orderNumber),
        activeOrderCount: increment(1),
      })
      console.log(`Order ${orderNumber} added to ${collectionName}/${productId}`)
      return true
    } else if (action === "remove") {
      await updateDoc(productRef, {
        currentlyInOrders: arrayRemove(orderNumber),
        activeOrderCount: increment(-1),
      })
      console.log(`Order ${orderNumber} removed from ${collectionName}/${productId}`)
      return true
    } else {
      console.error(`Invalid action: ${action}. Use "create" or "remove"`)
      return false
    }
  } catch (error) {
    console.error("Error managing product orders:", error)
    return false
  }
}
